// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"NewFoolScreen_foolScreen__HAgJf","subscribersBlock":"NewFoolScreen_subscribersBlock__TSo2R"};